module.exports = __webpack_public_path__ + "static/media/Logo_DM2.c72e054a.png";